import { render, staticRenderFns } from "./UserSearchItem.vue?vue&type=template&id=2f091c48&scoped=true"
import script from "./UserSearchItem.vue?vue&type=script&lang=ts"
export * from "./UserSearchItem.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchItem.vue?vue&type=style&index=0&id=2f091c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f091c48",
  null
  
)

export default component.exports